module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('label', {
    attrs: {
      "for": "donor-name"
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form__text",
    attrs: {
      "type": "text",
      "id": "donor-name",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-462754fa","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DonorInfo.vue
// module id = 1144
// module chunks = 0